import React, { FC } from "react";
import { styles, getThemedStyles } from "./UpgradeButton.styles";
import LockOutlineIcon from "@mui/icons-material/LockOutlined";
import { classNames } from "../../../../../../../utils/common/styling";
import { useCreatorThemeContext } from "../../../../../../../features/Common/modules/Theme/CreatorThemeContext";

export const DEFAULT_PAID_POST_CTA_LABEL = "Pay to Unlock";

export const UpgradeButton: FC<{
  onClick: () => void;
  ctaLabel?: string;
}> = ({ onClick, ctaLabel = DEFAULT_PAID_POST_CTA_LABEL }) => {
  const theme = useCreatorThemeContext();
  const themedStyles = getThemedStyles({ theme });
  return (
    <div
      className={classNames(styles.container, themedStyles.container)}
      onClick={onClick}
    >
      <LockOutlineIcon fontSize="small" />
      <div className={styles.upgradeText}>{ctaLabel}</div>
    </div>
  );
};
